import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import playCircle from '../../../public/assets/playCircle.png';
import { formatSecondsToDynamicTime } from '../../utils/helpers';
import VideoPopup from './VideoPopup';

export default function FeatureVideoCard({ video }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const getVideoIDFromYtUrl = (url) => {
    // eslint-disable-next-line no-useless-escape
    const videRegEx = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    // console.log('id ', url.match(videRegEx)[1])
    return url.match(videRegEx)[1];
  };
  const openModal = () => {
    const id = getVideoIDFromYtUrl(video?.url);
    const youtubeEmbedURL = `https://www.youtube.com/embed/${id}?autoplay=1`;
    setCurrentVideoUrl(youtubeEmbedURL);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVideoUrl(null);
  };
  return (
    <div
      className="rounded-lg p-1 flex w-full justify-center items-center lg:block lg:w-[312px] overflow-hidden flex-shrink-0 bg-white"
      key={video?.id}
    >
      <div className="flex relative lg:w-auto w-[40%]">
        <Image width={500} height={500} src={video?.thumbnail} alt="teacher-banner" className="self-start w-full lg:h-36 rounded lg:rounded-none lg:rounded-tl-lg lg:rounded-tr-lg" />
        <div className="flex absolute rounded lg:rounded-lg  top-0 left-0 w-100 h-100 bg-slate-700/40 min-w-full min-h-full items-center justify-center">
          <Image
            src={playCircle}
            width={48}
            height={48}
            alt="play-button"
            className="w-8 lg:w-12
                 absolute cursor-pointer"
            onClick={openModal}
          />
          <span className="bg-black/90 self-end absolute right-1 bottom-1 text-white px-1 text-sm font-medium">{formatSecondsToDynamicTime(video?.duration)}</span>
        </div>
      </div>
      <div className="lg:py-3 px-2 lg:w-auto  w-[60%]">
        <span className="w-full text-sm font-semibold lg:line-clamp-2 text-greyFont">
          {video?.name}
        </span>
      </div>
      {isModalOpen && <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />}
    </div>
  );
}
FeatureVideoCard.propTypes = {
  video: PropTypes.object.isRequired,
};
